import { useQuery } from "@tanstack/react-query";
import { materialStatus } from "./query";
import { PostModel } from "common/models/BaseModel";
import { IMaterialStatusGridFilter } from "./types";

export function GetMaterialStatuss(
  model: PostModel<IMaterialStatusGridFilter> | undefined
) {
  return useQuery(materialStatus.list(model));
}

export function GetMaterialStatus(Id: string | number | undefined) {
  return useQuery({
    ...materialStatus.getById(Id || ""),
    enabled: Boolean(Id),
  });
}

export function GetMaterialStatusValues() {
  return useQuery({
    ...materialStatus.getMaterialStatusValues(),
    refetchOnMount: true,
  });
}

export function GetMaterialStatusView(id: string | number | undefined, isOpen: boolean) {
  return useQuery({
    ...materialStatus.getViewById(id || ""),
    enabled: Boolean(id) && isOpen,
  });
}
